<tt-page class="col-xs-12 col-md-6 sp-0">
    <tt-card>
        <tt-button-goto ttText="add_new_oeestate_edit" ttGoto="oeestateedit" [ttGotoParms]="{ oeestate_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListOeeStates"></tt-list>
</tt-page>
